import { useEffect, useLayoutEffect, useState } from 'react';
import { ElementDimensions, useWindowDimensions } from '../../hooks/useWindowDimensions';
import { GRID_LAYOUT_FALLBACK_HEIGHT_PX, GRID_LAYOUT_FALLBACK_WIDTH_PX } from '../cpsGridTypes';

interface UseCpsGridLayoutParams {
  gridRef: React.RefObject<HTMLDivElement | null>;
  gridDataLength: number;
  selectedIndexId: number | undefined;
}

interface UseCpsGridLayoutResult {
  gridDimensions: ElementDimensions;
}

export const useCpsGridLayout = (params: UseCpsGridLayoutParams): UseCpsGridLayoutResult => {
  const { gridRef, gridDataLength, selectedIndexId } = params;
  const [gridDimensions, setGridDimensions] = useState<ElementDimensions>({ width: 0, height: 0 });
  const windowDimensions = useWindowDimensions();

  useEffect(() => {
    if (!gridRef.current) {
      return;
    }

    const paddingSize = 30;
    const rect = gridRef.current.getBoundingClientRect();
    const rawHeight = document.body.offsetHeight - rect.top - paddingSize - 30;
    const rawWidth = rect.width - paddingSize;
    const height = Number.isFinite(rawHeight) && rawHeight > 0 ? rawHeight : GRID_LAYOUT_FALLBACK_HEIGHT_PX;
    const width = Number.isFinite(rawWidth) && rawWidth > 0 ? rawWidth : GRID_LAYOUT_FALLBACK_WIDTH_PX;

    setGridDimensions({ height, width });
  }, [windowDimensions, selectedIndexId, gridRef]);

  useLayoutEffect(() => {
    if (!gridRef.current || gridDataLength > 0) {
      return;
    }

    const tableThread = gridRef.current.getElementsByClassName('k-table-thead')[0] as HTMLElement;
    const noRecordsWrapper = gridRef.current.getElementsByClassName('k-grid-table-wrap')[0] as HTMLElement;

    if (tableThread && noRecordsWrapper) {
      const tableThreadWidth = tableThread.getBoundingClientRect().width;
      noRecordsWrapper.style.width = `${tableThreadWidth}px`;
    }
  }, [gridDataLength, gridRef]);

  return { gridDimensions };
};
